@if (scheduleEnabled() && summary()) {
  <div class="flex items-center text-ui-gray-100">
    <mat-icon class="text-base h-4 w-4 mr-1">access_time</mat-icon>
    <span class="text-xs">{{ summary() }}</span>
  </div>
}
